import React, { useMemo, useEffect, useState } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";
import { getPositionTypes } from "common/services/payments.service";
import { normalize } from "common/lib/normalize";

const SelectCategory = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.category && validation.errors.category
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.category && validation.errors.category
            ? "red"
            : "#ced4da",
      },
    }),
  };
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getPositionTypes({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
          filters: {
            category: {
              $null: true,
            },
          },
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="category-field" className="form-label">
        Position Type Category
      </Label>
      <Select
        name="category"
        id="category"
        value={
          validation.values.category.value ? validation.values.category : null
        }
        isSearchable={false}
        placeholder="Select position type category"
        onChange={(value: any) => {
          validation.setFieldValue("category", value);
          validation.setFieldError("category", "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched("category", true)}
        className={
          validation.touched.category && validation.errors.category
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        loading={loading}
      />
      <FormFeedback>{validation.errors.category?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectCategory;
